// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GaugeCard_wrapper__fx7ap"};